<template>
  <div class="print">
    <section class="section-1 mb-10">
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col />
          <col />
          <col width="140" />
          <col />
          <col />
          <col width="140" />
          <col />
          <col />
          <col />
        </colgroup>
        <tr>
          <td colspan="11">
            <div class="print-title">{{ header.year }}년 안전·보건 회의록</div>
          </td>
        </tr>

        <tr>
          <th>일시</th>
          <td colspan="3">
            <div>
              <p>{{ form.회의일 }}</p>
              <p>{{ exportConferenceTime }}</p>
            </div>
          </td>
          <th>장소</th>
          <td colspan="2">
            <div>{{ form.회의장소 }}</div>
          </td>
          <th>회의구분</th>
          <td colspan="3">
            <div>{{ form.회의구분 }}</div>
          </td>
        </tr>

        <tr>
          <th colspan="5">참석인원</th>
          <td colspan="6">
            <div>{{ form.참석인원 }}명</div>
          </td>
        </tr>

        <tr>
          <th colspan="2">협의 및 의결사항</th>
          <td colspan="9">
            <div>{{ form.협의및의결사항 }}</div>
          </td>
        </tr>
        <tr>
          <th colspan="2">기타사항</th>
          <td colspan="9">
            <div>{{ form.기타사항 }}</div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 참석자 명단 -->
    <div v-for="(tableGroup, tableIndex) in attendanceTableGroups" :key="`table_${tableIndex}`">
      <section v-if="tableIndex === 0" class="section-2 mb-10">
        <table class="w-full">
          <colgroup>
            <col width="140" />
            <col />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col />
          </colgroup>
          <tr>
            <td colspan="11">
              <div class="print-title">{{ header.year }}년 안전·보건 회의 참석자 명부</div>
            </td>
          </tr>
          <tr>
            <th>일시</th>
            <td colspan="3">
              <div>
                <p>{{ form.회의일 }}</p>
                <p>{{ exportConferenceTime }}</p>
              </div>
            </td>
            <th>장소</th>
            <td colspan="2">
              <div>{{ form.회의장소 }}</div>
            </td>
            <th>회의구분</th>
            <td colspan="3">
              <div>{{ form.회의구분 }}</div>
            </td>
          </tr>
          <tr>
            <th colspan="5">참석인원</th>
            <td colspan="6">
              <div>{{ form.참석인원 }}명</div>
            </td>
          </tr>
          <tr>
            <th colspan="3">직책</th>
            <th colspan="2">직급</th>
            <th colspan="2">성명</th>
            <th colspan="2">서명</th>
            <th colspan="2">비고</th>
          </tr>
          <tr v-for="(item, i) in tableGroup" :key="`attendance_${tableIndex}_${i}`">
            <td colspan="3" class="text-left">{{ item.직책 || "" }}</td>
            <td colspan="2">{{ item.직급 || "" }}</td>
            <td colspan="2">{{ item.성명 || "" }}</td>
            <td colspan="2">
              <div class="w-full flex-1 p-1" style="height: 35px">
                <img v-if="item.서명" :src="item.서명" height="35px" alt="Signature" class="signatureImg" />
                <div v-else class="signatureImg"></div>
              </div>
            </td>
            <td colspan="2">{{ item.비고 || "" }}</td>
          </tr>
        </table>
      </section>

      <section v-else class="section-2 mb-10 page-break">
        <table class="w-full">
          <colgroup>
            <col width="140" />
            <col />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col />
          </colgroup>
          <tr>
            <td colspan="11">
              <div class="print-title">{{ header.year }}년 안전·보건 회의 참석자 명부</div>
            </td>
          </tr>
          <tr>
            <th colspan="3">직책</th>
            <th colspan="2">직급</th>
            <th colspan="2">성명</th>
            <th colspan="2">서명</th>
            <th colspan="2">비고</th>
          </tr>
          <tr v-for="(item, i) in tableGroup" :key="`attendance_${tableIndex}_${i}`">
            <td colspan="3" class="text-left">{{ item.직책 || "" }}</td>
            <td colspan="2">{{ item.직급 || "" }}</td>
            <td colspan="2">{{ item.성명 || "" }}</td>
            <td colspan="2">
              <div class="w-full flex-1 p-1">
                <img v-if="item.서명" :src="item.서명" height="48px" alt="Signature" class="signatureImg" />
                <div v-else class="signatureImg"></div>
              </div>
            </td>
            <td colspan="2">{{ item.비고 || "" }}</td>
          </tr>
        </table>
      </section>
    </div>

    <!-- 사진대지 -->
    <div v-for="(tableGroup, tableIndex) in pictureTableGroups" :key="`table_${tableIndex}`">
      <section v-if="tableIndex === 0" class="section-3 mb-10">
        <table class="w-full">
          <colgroup>
            <col width="140" />
            <col />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col />
          </colgroup>
          <tr>
            <td colspan="11">
              <div class="print-title">{{ header.year }}년 안전·보건 회의 사진대지</div>
            </td>
          </tr>
          <tr>
            <th>일시</th>
            <td colspan="3">
              <div>
                <p>{{ form.회의일 }}</p>
                <p>{{ exportConferenceTime }}</p>
              </div>
            </td>
            <th>장소</th>
            <td colspan="2">
              <div>{{ form.회의장소 }}</div>
            </td>
            <th>회의구분</th>
            <td colspan="3">
              <div>{{ form.회의구분 }}</div>
            </td>
          </tr>
          <tr>
            <th colspan="5">참석인원</th>
            <td colspan="6">
              <div>{{ form.참석인원 }}명</div>
            </td>
          </tr>

          <template v-for="(item, i) in tableGroup">
            <tr :key="`picture2img_${tableIndex}_${i}`">
              <td colspan="11">
                <img v-if="item.path" :src="item.path" width="100%" class="max-w-full w-auto object-contain" />
              </td>
            </tr>
            <tr :key="`picture2input${tableIndex}_${i}`">
              <td>내용</td>
              <td colspan="10">{{ item.input }}</td>
            </tr>
          </template>
        </table>
      </section>

      <section v-else class="section-3 mb-10 page-break">
        <table class="w-full">
          <colgroup>
            <col width="140" />
            <col />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col width="140" />
            <col />
            <col />
            <col />
          </colgroup>
          <tr>
            <td colspan="11">
              <div class="print-title">{{ header.year }}년 안전·보건 회의 사진대지</div>
            </td>
          </tr>

          <template v-for="(item, i) in tableGroup">
            <tr :key="`picture2img_${tableIndex}_${i}`">
              <td colspan="11">
                <img v-if="item.path" :src="item.path" width="100%" class="max-w-full w-auto object-contain" />
              </td>
            </tr>
            <tr :key="`picture2input${tableIndex}_${i}`">
              <td>내용</td>
              <td colspan="10">{{ item.input }}</td>
            </tr>
          </template>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: { PrintCheckbox },

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
    header: Object,
  },

  computed: {
    exportConferenceTime() {
      if (!this.form.실시시간 || !this.form.실시시간.sTime || !this.form.실시시간.eTime) {
        return "";
      }

      if (this.form.실시시간.sTime.length < 5 || this.form.실시시간.eTime.length < 5) {
        return "";
      }

      const sTime = this.form.실시시간.sTime.substring(0, 5);
      const eTime = this.form.실시시간.eTime.substring(0, 5);

      return `(${sTime} ~ ${eTime})`;
    },

    attendanceTableGroups() {
      const rowsPerTable = 25;
      const attendanceList = this.form.참석자명단 || [];
      const groups = [];

      // 25개씩 그룹으로 나누기
      for (let i = 0; i < attendanceList.length; i += rowsPerTable) {
        const group = attendanceList.slice(i, i + rowsPerTable);
        // 25개가 안되면 빈 객체로 채우기
        while (group.length < rowsPerTable) {
          group.push({});
        }
        groups.push(group);
      }

      // 참석자가 없으면 빈 25개 행으로 구성된 그룹 하나 생성
      if (groups.length === 0) {
        const emptyGroup = Array(rowsPerTable).fill({});
        groups.push(emptyGroup);
      }

      return groups;
    },

    pictureTableGroups() {
      const rowsPerTable = 2;
      const pictureList = this.form.photoList || [];
      const groups = [];

      // 2개씩 그룹으로 나누기
      for (let i = 0; i < pictureList.length; i += rowsPerTable) {
        const group = pictureList.slice(i, i + rowsPerTable);
        // 2개가 안되면 빈 객체로 채우기
        while (group.length < rowsPerTable) {
          group.push({});
        }
        groups.push(group);
      }

      // 사진이 없으면 빈 2개 행으로 구성된 그룹 하나 생성
      if (groups.length === 0) {
        const emptyGroup = Array(rowsPerTable).fill({});
        groups.push(emptyGroup);
      }

      return groups;
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
    text-decoration: underline;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3c3c3c;
    padding: 1.25rem 0rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      //padding: 1.0rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 기본정보 */
  .section-1 .section-2 {
    td div {
      border: none;
    }
  }
}

@media print {
  .section-1 {
    height: 93vh;
    display: flex;
    flex-direction: column;

    table {
      height: 100%;

      tr:nth-child(4) {
        // 협의 및 의결사항
        height: 55vh;
      }

      tr:nth-child(5) {
        // 기타사항
        height: 20vh;
      }
    }
  }
  .section-2 {
    height: 100vh;
    display: flex;
    flex-direction: column;

    table {
      height: 100%;
    }
  }
  .section-3 {
    height: 100vh;
    display: flex;
    flex-direction: column;

    table {
      height: 100%;

      tr:nth-child(4) {
        // 첫 번째 이미지
        height: 40vh;
      }

      tr:nth-child(5) {
        // 첫 번째 내용
        height: 48px;
      }

      tr:nth-child(6) {
        // 두 번째 이미지
        height: 40vh;
      }

      tr:nth-child(7) {
        // 두 번째 내용
        height: 48px;
      }
    }
  }
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  thead {
    display: table-header-group;
  }
}
</style>
